import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import { EntityService } from "./entity-service";
import { AclService } from "./acl-service";


export class SharedUsageService {
    static $inject = ["$q", "simpleCache", "entityService", "aclService"];

    deferred = this.$q.defer<Models.ICharacteristicTemplate[]>();

    constructor(private $q: ng.IQService, private simpleCache: ng.ICacheObject, private entityService: EntityService, private aclService: AclService) {

    }
    /*
     * Gets and caches associable child templates, especially for the nested Asset/usage/amount data
     * @param parentCharTypeID charTypeID of parent entity
     * @param parentTempalteID templateID of the parent entity
     * @param childCharTypeID charTypeID of child entity
     */
    getAssociatedTemplates(parentCharTypeID: number, parentTemplateID: number, childCharTypeID: number) {

        // make a unique hash
        var key = "pc" + parentCharTypeID + "pt" + parentTemplateID + "cc" + childCharTypeID;
        // make a flag to prevent parallel requests
        var busyKey = key + "busy";
        var output = this.simpleCache.get<Models.ICharacteristicTemplate[]>(key);
        var busy = this.simpleCache.get(busyKey);
        if (output == null && busy == null) {
            this.simpleCache.put(busyKey, true);
            this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, parentTemplateID, childCharTypeID)
                .then((result) => {
                    output = result.filter(ct => Utils.AclUtil.hasReadAccess(this.aclService.acls, ct.acl));
                    this.simpleCache.put(key, output);
                    this.deferred.resolve(output);
                });
        } else if (output != null) {
            this.deferred.resolve(output);
        }

        return this.deferred.promise;
    }
}
